const prefix = 'SourcingProjectProposal';
export enum SourcingProjectProposalField {
  COUNT = `${prefix}.count`,
}
